webpackJsonp([45],{

/***/ 135:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


__webpack_require__(136);

var $ = __webpack_require__(0);

$(window).scroll(function () {
    var scroll = $(window).scrollTop();
    $('.o-dossier-heading__bg').each(function () {
        var $element = $(this);
        $element.css({
            width: 100 + scroll / 8 + "%"
        });
    });
});

/***/ }),

/***/ 136:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ })

},[135]);


// WEBPACK FOOTER //
// o-dossier-heading.js